module.exports = __webpack_public_path__ + "img/fiveFace.98ae2447.svg";